module.exports = __webpack_public_path__ + "static/media/volunt.350f222c.webp";